import { IStyle, mergeStyleSets } from "@fluentui/react";

export interface ICookieConsentBannerStyles {
  root: string;
  content: string;
  text: string;
  link: string;
  buttonContainer: string;
  acceptButton: string;
  declineButton: string;
}

export const getCookieConsentBannerStyles = (): ICookieConsentBannerStyles =>
  mergeStyleSets({
    root: {
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      width: "100%",
      backgroundColor: "#f3f2f1",
      color: "#323130",
      fontFamily: "Segoe UI, sans-serif",
      padding: "1rem",
      boxShadow: "0 -2px 6px rgba(0,0,0,0.1)",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      zIndex: 99999,
      transition: "transform 0.3s ease-in-out",
      "@media (max-width: 768px)": {
        flexDirection: "column",
        alignItems: "stretch",
        gap: "1rem",
        padding: "0.75rem",
      },
    } as IStyle,
    content: {
      display: "flex",
      flexDirection: "column",
      gap: "0.5rem",
      "@media (max-width: 768px)": {
        alignItems: "center",
        textAlign: "center",
      },
    } as IStyle,
    text: {
      fontSize: "14px",
      lineHeight: "1.4",
      margin: 0,
      "@media (max-width: 768px)": {
        fontSize: "13px",
        maxWidth: "100%",
      },
    } as IStyle,
    link: {
      color: "#0078d4",
      textDecoration: "underline",
      ":hover": {
        color: "#106ebe",
      },
      ":focus": {
        outline: "2px solid #0078d4",
        outlineOffset: "2px",
      },
    } as IStyle,
    buttonContainer: {
      display: "flex",
      gap: "0.5rem",
      flexShrink: 0,
      "@media (max-width: 768px)": {
        justifyContent: "center",
        width: "100%",
      },
    } as IStyle,
    acceptButton: {
      // Styles will be applied via Fluent UI PrimaryButton
    } as IStyle,
    declineButton: {
      // Styles will be applied via Fluent UI DefaultButton
    } as IStyle,
  });
